var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPositionsIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63830",
    "data-name": "Rectangle 63830",
    width: 23,
    height: 19.522,
    fill: "none",
    stroke: "#0c66e4",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44947",
    "data-name": "Group 44947",
    transform: "translate(69 -229)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63934",
    "data-name": "Rectangle 63934",
    width: 25,
    height: 25,
    transform: "translate(-69 229)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44944",
    "data-name": "Group 44944",
    transform: "translate(-123 43)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    x2: 6.183,
    transform: "translate(63.409 199.876)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44238",
    "data-name": "Group 44238",
    transform: "translate(55 188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44237",
    "data-name": "Group 44237",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88433",
    "data-name": "Path 88433",
    d: "M17.751,12.229h3.864a.773.773,0,0,0,.773-.773V4.5a.773.773,0,0,0-.773-.773H1.523A.773.773,0,0,0,.75,4.5v6.955a.773.773,0,0,0,.773.773H5.386",
    transform: "translate(-0.069 -0.343)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88434",
    "data-name": "Path 88434",
    d: "M21.694,13.09v6.183a.773.773,0,0,1-.773.773H2.374a.773.773,0,0,1-.773-.773V13.09",
    transform: "translate(-0.147 -1.204)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88435",
    "data-name": "Path 88435",
    d: "M16.069,12.2v1.093a1.59,1.59,0,0,0,1.394,1.6,1.546,1.546,0,0,0,1.7-1.538V12.2a.386.386,0,0,0-.386-.387H16.456A.387.387,0,0,0,16.069,12.2Z",
    transform: "translate(-1.478 -1.087)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88436",
    "data-name": "Path 88436",
    d: "M5.856,12.2v1.093A1.59,1.59,0,0,0,7.25,14.9a1.546,1.546,0,0,0,1.7-1.538V12.2a.386.386,0,0,0-.386-.387H6.243A.387.387,0,0,0,5.856,12.2Z",
    transform: "translate(-0.539 -1.087)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88437",
    "data-name": "Path 88437",
    d: "M15.79,3.455V1.413A.724.724,0,0,0,15.018.75H9.608a.724.724,0,0,0-.773.663V3.455",
    transform: "translate(-0.813 -0.069)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositionsIco);
export default __webpack_public_path__ + "static/media/positions-ico.3e7e066f4641d0ddb969872af62885cb.svg";
export { ForwardRef as ReactComponent };